(function() {
  var btn = document.querySelector('.cart__checkout-button');
  if (!btn) return;

  var footer = document.getElementById('main-cart-footer');
  if (!footer) return;

  function checkVisibility() {
    if (btn.style.visibility === 'hidden') {
      footer.style.display = 'none';
    } else {
      footer.style.display = '';
    }
  }

  // totals__total の「見積もり合計」を「小計」に変換
  var totalsLabel = document.querySelector('.totals__total');
  if (totalsLabel) {
    totalsLabel.textContent = totalsLabel.textContent.replace('見積もり合計', '小計');
  }

  // 初回チェック
  checkVisibility();

  // style属性の変更を監視
  var observer = new MutationObserver(function() {
    checkVisibility();
  });

  observer.observe(btn, {
    attributes: true,
    attributeFilter: ['style']
  });
})();